module.exports = __webpack_public_path__ + "static/media/menu.98e5b3d5.svg";